var common = {
  black: "#000",
  white: "#fff",
};
var grey = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#d5d5d5",
  A200: "#aaaaaa",
  A400: "#303030",
  A700: "#616161",
};

export const themeObjectDark = {
  palette: {
    mode: "dark",
    text: {
      primary: common.white,
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(255, 255, 255, 0.42)",
      hint: "rgba(255, 255, 255, 0.5)",
      icon: "rgba(255, 255, 255, 0.5)",
      softer: "rgba(255,255,255,.85)",
      selected: "#000",
    },
    divider: "rgba(255, 255, 255, 0.12)",
    // Badges and alerts: the same pink family as the light theme, a little
    // brighter so it reads on a dark surface.
    secondary: {
      light: "#ffb74d",
      main: "#f4558a",
      dark: "#ff6e40",
      contrastText: "#fff",
    },
    background: {
      paper: "#1f2227",
      default: "#16181c",
      // A step away from the page, for areas such as the message thread.
      subtle: "#1a1c20",
      light: "#2b2f36",
      lighter: "#383d46",
    },
    // Colours with a meaning (answered, missed, urgent...). `main` is for
    // text and icons, `soft` for the tint behind them. Brighter here than
    // in the light theme, so they read on a dark surface.
    tone: {
      success: { main: "#5fd38a", soft: "rgba(95, 211, 138, 0.16)" },
      danger: { main: "#ff7b76", soft: "rgba(255, 123, 118, 0.16)" },
      warning: { main: "#ffb74d", soft: "rgba(255, 183, 77, 0.16)" },
      urgent: { main: "#ff7aa8", soft: "rgba(255, 122, 168, 0.16)" },
      brand: { main: "#5cc8f5", soft: "rgba(92, 200, 245, 0.16)" },
      muted: { main: "#a9b0bb", soft: "rgba(169, 176, 187, 0.16)" },
    },
    action: {
      active: common.white,
      hover: "rgba(255, 255, 255, 0.08)",
      hoverOpacity: 0.08,
      selected: "rgba(255, 255, 255, 0.16)",
      selectedOpacity: 0.16,
      disabled: "rgba(255, 255, 255, 0.3)",
      disabledBackground: "rgba(255, 255, 255, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(255, 255, 255, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.24,
    },
    primary: {
      light: "#7986cb",
      main: "#3f51b5",
      dark: "#303f9f",
      hr: "rgba(255, 255, 255, 0.12)",
      success: "#00C853",
      lighter: "#e3e7fc",
      darkerGreen: "114B5F",
      contrastText: "#fff",
    },
  },
};

export const themeObjectLight = {
  palette: {
    mode: "light",
    primary: {
      lighter: "#ecf8ff",
      light: "#01BAEF",
      main: "#2282AB",
      dark: "#1b6888",
      darkerGreen: "114B5F",
      contrastText: "#fff",
      hr: "#cfd8dc",
      success: "#00C853",
    },
    secondary: {
      light: "#faa222",
      main: "#E91e63",
      dark: "#ff3d00",
      contrastText: "#fff",
    },
    text: {
      primary: "#000",
      secondary: "rgba(0,0,0,.54)",
      disabled: "#cbcbcb",
      hint: "#ff3d00",
      softer: "#222",
      selected: "#FFF",
    },
    background: {
      paper: "#fff",
      default: "#fafafa",
      // A step away from the page, for areas such as the message thread.
      subtle: "#f3f5f8",
      light: grey[300],
      lighter: grey[200],
    },
    // Colours with a meaning (answered, missed, urgent...). `main` is for
    // text and icons, `soft` for the tint behind them.
    tone: {
      success: { main: "#1f8f4a", soft: "rgba(46, 158, 85, 0.12)" },
      danger: { main: "#d0312d", soft: "rgba(229, 50, 45, 0.11)" },
      warning: { main: "#b26d00", soft: "rgba(232, 147, 12, 0.14)" },
      urgent: { main: "#c2185b", soft: "rgba(233, 30, 99, 0.10)" },
      brand: { main: "#2282AB", soft: "rgba(1, 186, 239, 0.13)" },
      muted: { main: "#5f6570", soft: "rgba(138, 143, 152, 0.16)" },
    },
    action: {
      disabled: "#cbcbcb",
    },
  },
  '@global': {
    '*::-webkit-scrollbar': {
      width: '0.4em'
    },
    '*::-webkit-scrollbar-track': {
      '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)'
    },
    '*::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0,0,0,.1)',
      outline: '1px solid slategrey'
    }
  }
};